import Gateway from 'src/utils/Gateway';

export function getUserCombos(params = {}) {
    return Gateway.post('/v1/basic/privilege/combo/userCombos', params);
}

export function getUserCombosBatch(params = {}) {
    return Gateway.post('/v1/combo/userCombosBatch', params);
}
